// src/components/ProfilePage.js
import React from 'react';
const ProfilePage = () => <h1>Profile - User information here!</h1>;
export default ProfilePage;